import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-slate-200 bg-slate-50 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-76" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-77" data-mp="9t1nh6wuedbj">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm sm:p-12" data-id="element-78" data-mp="etpmaerbbygb">
          <span className="inline-flex rounded-full bg-teal-50 p-4 text-teal-700" data-id="element-79" data-mp="sldwgci04cun">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-80" data-mp="xim8dvck3kng" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-81" data-mp="12k37pmfe6z1x">
            7-Day <span className="text-teal-700" data-id="element-82" data-mp="17ims3iec82s6">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-83" data-mp="25sylow6dxoit">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs,{' '}
            <span className="font-semibold text-slate-900" data-id="element-84" data-mp="1vuit0orpm777">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}